/**
 * Сшивка уличного плеча с внутренним маршрутом (BACKLOG №23, часть 2).
 * Пользователь вне площадки (гео дальше OFF_SITE_M от сети) → внешний
 * навигатор ведёт до входа (/api/route-ext, цепочка провайдеров), дальше —
 * мануальная дорожная сеть RVF. Чистая логика отделена от fetch.
 */
import { haversineM, type LonLat } from '@app/geo'
import { type RouteStart, resolveStart, type Venue } from '@app/rvf'

/** Дальше этого от ближайшего узла сети — считаем «вне площадки». */
export const OFF_SITE_M = 120

export interface ExternalLeg {
  readonly polyline: readonly LonLat[]
  readonly durationS: number
  readonly provider: string
}

/**
 * Нужно ли внешнее плечо: гео есть и дальше OFF_SITE_M от любого узла сети.
 * Возвращает точку входа площадки (старт внутреннего маршрута) или null.
 */
export function offSiteEntrance(venue: Venue, geo: LonLat | null): RouteStart | null {
  if (!geo || venue.network.nodes.length === 0) return null
  let nearestM = Number.POSITIVE_INFINITY
  for (const node of venue.network.nodes) {
    const d = haversineM(geo, node.point)
    if (d < nearestM) nearestM = d
  }
  if (nearestM <= OFF_SITE_M) return null
  // Вход площадки: первый якорь → gate-узел → первый узел (как resolveStart).
  return resolveStart(venue, {})
}

/** Запрос уличного плеча у цепочки провайдеров сервера; null — молча (нет цепочки). */
export async function fetchExternalLeg(from: LonLat, to: LonLat): Promise<ExternalLeg | null> {
  try {
    const params = new URLSearchParams({
      from_lon: String(from[0]),
      from_lat: String(from[1]),
      to_lon: String(to[0]),
      to_lat: String(to[1]),
    })
    const res = await fetch(`/api/route-ext?${params}`)
    if (!res.ok) return null
    const body = (await res.json()) as {
      polyline: LonLat[]
      duration_s: number
      provider: string
    }
    if (!Array.isArray(body.polyline) || body.polyline.length < 2) return null
    return { polyline: body.polyline, durationS: body.duration_s, provider: body.provider }
  } catch {
    return null
  }
}
